"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Assets = void 0;
const client_1 = require("@arkecosystem/client");
class Assets extends client_1.Resource {
    async all(query) {
        return this.sendGet("nft/assets", query);
    }
    async get(id) {
        return this.sendGet(`nft/assets/${id}`);
    }
    async wallet(id) {
        return this.sendGet(`nft/assets/${id}/wallets`);
    }
    async walletAssets(publicKey, query) {
        return this.sendGet(`nft/assets/wallet/${publicKey}`, query);
    }
    async searchByAsset(payload, query) {
        return this.sendPost("nft/assets/search", payload, query);
    }
}
exports.Assets = Assets;
//# sourceMappingURL=assets.js.map